module.exports = __webpack_public_path__ + "static/photography-9d9cd38635c013bb4a434cab88731b88.jpg";